import type BaseApp from './App';
import type { FileFormatInfo } from '@egr/xbox/utils/FileFormats';

import i18next from 'i18next';

import { messageManager } from '@egr/xbox/messagebar/MessageManager';

export type AdditionalShareFormat =
    | 'snapshot'
    | 'articlelist'
    | 'productsheet'
    | 'gallery'
    | 'pbox'
    | 'gallerySelection'
    | 'excel'
    | 'opl'
    | 'ifc'
    | 'jpg'
    | 'planningUrl'
    | 'OBX'
    | 'USDZwithWalls'
    | 'savedImages'
    | 'articleObx'
    | 'comparePDF'
    | 'savedInspirations'
    | 'GLBwithWalls'
    | 'modelList'
    | 'modelListExcel';
export const GEOMETRY_FORMATS = ['3DS', 'DWG', 'FBX', 'GLB', 'USDZ', 'OBK', 'RVT'] as const;

type GeometryShareFormatTuple = typeof GEOMETRY_FORMATS ;
export type GeometryShareFormat = GeometryShareFormatTuple[number];

export function isGeometryShareFormat(value: string): value is GeometryShareFormat {
    return GEOMETRY_FORMATS.includes(value as GeometryShareFormat);
}

export type ShareFormat = GeometryShareFormat | AdditionalShareFormat;

export abstract class ShareCallbacks<App extends BaseApp = BaseApp> {
    constructor(protected app: App) {
        this.shareError = this.shareError.bind(this);
        this.shareUrl = this.shareUrl.bind(this);
    }

    public abstract shareUrl(uri: string, fileFormat: FileFormatInfo, filename?: string): Promise<void>;

    public shareError(keepActiveMessage: boolean = false): void {
        if (
            keepActiveMessage &&
            messageManager.snapshot.message != null ||
            messageManager.snapshot.modalMessage != null
        ) {
            return;
        }

        messageManager.showMessage(i18next.t('Sharing failed'));
    }
}